module.exports = __webpack_public_path__ + "static/img/theme4.bb005a6e.png";